import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref } from "vue"
import _imports_0 from '@/assets/images/t-logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, "Ещё", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-6 h-6"
}, null, -1)

import { ref, watch } from "vue";
import { RouteRecordRaw } from "vue-router";

import { routes } from "@/router/routes";
import { usePermissions } from "@/use/usePermissions";
import { useStore } from "@/use/useStore";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";

import UiAppBar from "@/components/UiAppBar.vue";
import UiIconBtn from "@/components/ui/UiIconBtn.vue";
import UiIcon from "@/components/ui/UiIcon.vue";

import AccountSelect from "@/components/AccountSelect.vue";
import AppTabbar from "@/components/AppTabbar.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import AccountInfo from "@/features/home/components/AccountInfo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'More',
  setup(__props) {

const { currentUser } = useStore();
const { isAllow } = usePermissions();

const availableRoutes = ref<RouteRecordRaw[]>([]);

function calculateRoutes() {
  const index = routes.length > 5 ? 4 : 5;

  const filteredRoutes = [...routes].filter((route) => {
    if (route.meta?.hidden === true) {
      return;
    }

    let priority = route.meta?.priority;

    if (route.meta?.allowFor && !isAllow(route.meta.allowFor)) {
      return;
    }

    if (route.meta?.allowFor && !isAllow(route.meta.allowFor) && priority) {
      priority = (1000 - priority) * -1;
    }

    return { ...route, meta: { ...route.meta, priority } };
  });

  availableRoutes.value = filteredRoutes.slice(index, routes.length);
}

watch(() => currentUser.value?.id, calculateRoutes, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "Ещё"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(UiGroup, null, {
        header: _withCtx(() => [
          _createVNode(UiHeader, { title: "Выбранный аккаунт" })
        ]),
        default: _withCtx(() => [
          _createVNode(UiCard, null, {
            default: _withCtx(() => [
              _createVNode(AccountInfo)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(UiGroup, null, {
        header: _withCtx(() => [
          _createVNode(UiHeader, { title: "Дополнительно" })
        ]),
        default: _withCtx(() => [
          _createVNode(UiCard, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRoutes.value, (route) => {
                return (_openBlock(), _createBlock(UiCell, {
                  key: route.path,
                  onClick: ($event: any) => (_ctx.$router.replace(route.path))
                }, {
                  left: _withCtx(() => [
                    (route.meta?.icon)
                      ? (_openBlock(), _createBlock(UiIcon, {
                          key: 0,
                          icon: route.meta.icon
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(route.meta?.title), 1)
                  ]),
                  right: _withCtx(() => [
                    _createVNode(UiIcon, {
                      size: 16,
                      icon: "ChevronRight",
                      class: "text-gray-400 self-center"
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128)),
              _createVNode(UiCell, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
                title: "Настройки",
                expandable: ""
              }, {
                left: _withCtx(() => [
                  _createVNode(UiIcon, { icon: "Cog" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(currentUser)?.userGroups.find((g) => g.name === 'PARENT'))
        ? (_openBlock(), _createBlock(UiGroup, { key: 0 }, {
            header: _withCtx(() => [
              _createVNode(UiHeader, { title: "Помощь" })
            ]),
            default: _withCtx(() => [
              _createVNode(UiCard, null, {
                default: _withCtx(() => [
                  _createVNode(UiCell, {
                    title: "Голосовой центр поддержки",
                    description: "+7 (4162) 380-978"
                  }, {
                    left: _withCtx(() => [
                      _createVNode(UiIcon, { icon: "Phone" })
                    ]),
                    _: 1
                  }),
                  _createVNode(UiCell, {
                    title: "Чат поддержки Telegram",
                    description: "+7 (924) 041 88-99",
                    multiline: ""
                  }, {
                    left: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})